import {makeForgotPasswordRecoverUserInfo} from 'main/factories/usecases';
import {ForgotPasswordRecoverUserInfoParams} from './types.js';

export async function forgotPasswordRecoverUserInfo({
	signal,
	...userInfoParams
}: ForgotPasswordRecoverUserInfoParams) {
	const response = await makeForgotPasswordRecoverUserInfo().forgotPasswordRecoverUserInfo({
		signal,
		...userInfoParams,
	});

	return response;
}
